import { CITATIONS_LIST_CONTAINER } from '../classnames/scientific-citations';
import CitationComponent from './citation-component';

export default class CitationsRenderer {
  citationsListContainer = document.querySelector(`.${CITATIONS_LIST_CONTAINER}`);
  citationsDB = window.citationsDB;

  constructor({ citationIds }) {
    this.citationIds = citationIds;
  }

  createCitation = (id, index) => (
    (new CitationComponent({ citation: { ...this.citationsDB[id], index: index + 1 }})).render()
  );

  render = () => {
    const citationsElements = this.citationIds.map(this.createCitation);
    citationsElements.forEach((node) => this.citationsListContainer.append(node));
  };
}
